import { t } from '@transifex/native';

import type { Country } from 'pkg/api/models/country';
import type { Group } from 'pkg/api/models/group';
import { primaryColor } from 'pkg/colorconverter';

export function getPrimaryColor(group: Partial<Group>) {
	const color = group?.primaryColor;

	if (color && color.indexOf(':') !== -1) {
		return color.split(':').pop();
	}

	return null;
}

export function getPrimaryColorValue(group: Partial<Group>): string {
	let primaryColor = group?.primaryColor ?? '';

	if (primaryColor?.startsWith('hsl:')) {
		primaryColor = primaryColor.replace('hsl:', 'hsl(');
		primaryColor += ')';
	}

	return primaryColor;
}

export function getPrimaryColorStylesheetString(
	group: Partial<Group>,
	opacity: number = 1
) {
	if (!group) return null;

	const color = getPrimaryColor(group);

	if (color) {
		return `hsla(${color}, ${opacity})`;
	}

	return null;
}

export function getColorProfileGradient(group: Partial<Group>) {
	if (!group) {
		return null;
	}
	let color = getPrimaryColor(group);
	if (!color) {
		return null;
	}

	color = primaryColor(color).replace('hsl(', '').replace(')', '');

	let gradientColors = [];
	const hue = color.split(',')[0];
	const saturation = color.split(',')[1];
	const lum = parseInt(color.split(',')[2].replace('%', ''));

	if (lum > 15 && lum < 90) {
		gradientColors.push(`hsl(${hue}, ${saturation}, ${lum + 10}%)`);
		gradientColors.push(`hsl(${hue}, ${saturation}, ${lum}%)`);
		gradientColors.push(`hsl(${hue}, ${saturation}, ${lum - 15}%)`);
	} else if (lum < 15) {
		gradientColors.push(
			`hsl(${hue}, ${saturation}, ${lum + (15 - lum) + 10}%)`
		);
		gradientColors.push(`hsl(${hue}, ${saturation}, ${lum}%)`);
	} else {
		gradientColors.push(`hsl(${hue}, ${saturation}, ${lum}%)`);
		gradientColors.push(
			`hsl(${hue}, ${saturation}, ${lum - (100 - lum) - 15}%)`
		);
	}

	return gradientColors.join(', ');
}

export function getExportFields(country: Country) {
	let fields = [
		{ key: 'firstName', label: t(`First name`) },
		{ key: 'lastName', label: t(`Last name`) },
		{ key: 'gender', label: t(`Gender`) },
		{ key: 'email', label: t(`Email`) },
		{ key: 'phoneNumber', label: t(`Phone number`) },
		{ key: 'address', label: t(`Address`) },
		{ key: 'city', label: t(`City`) },
		{ key: 'region', label: t(`Region`) },
		{ key: 'postalCode', label: t(`Post code`) },
		{ key: 'nationality', label: t(`Nationality`) },
		{ key: 'personalId', label: t(`Personal ID number`) },
		{ key: 'dateOfBirth', label: t(`Date of birth`) },
		{
			key: 'connectedParents',
			label: t(`Parents`),
		},
		{ key: 'connectedChild', label: t(`Children`) },
	];

	if (country?.code !== 'SE' || !!!country?.code) {
		fields = fields.filter((i) => i.key !== 'personalId');
	}

	return fields;
}
